import { useQuery } from 'react-query'
import settings from '../../components/settings'
import { getCalendar } from '../../../utils/badaAppointmentApi'

const DAY = 24 * 60 * 60 * 1000
const MAX_DAYS = 60
const NOW = new Date()
const NOW_DATE = NOW.toISOString().split('T')[0]
const TOMORROW = new Date(NOW.getTime() + DAY)
const TOMORROW_DATE = TOMORROW.toISOString().split('T')[0]
const MAX_DATE = new Date(NOW.getTime() + MAX_DAYS * DAY)
  .toISOString()
  .split('T')[0]

export const getDateRange = (meetingTypeId) => {
  let specialMeetingtype = false
  if (settings.brand === 'magnet') {
    switch (parseInt(meetingTypeId, 10)) {
      case 5: // 3 slot in-store TEST
      case 6: // discovery TEST
      case 7: // 3 slot in-store PROD
      case 8: // discovery PROD
      case 11: // 3 slot in-store PROD - magnet2 || 3 slot in-store TEST - magnettest2
      case 12: // discovery PROD - magnet2 || discovery TEST - magnettest2
        specialMeetingtype = true
        break
      default:
        break
    }
  }

  const fromDate =
    settings.disableSameDayBooking && !specialMeetingtype
      ? TOMORROW_DATE
      : NOW_DATE

  return { fromDate, toDate: MAX_DATE }
}

export const useCalendar = (
  {
    appointmentId,
    locationId,
    serviceId,
    serviceProviderId,
    subsystem,
    fromDate,
    toDate,
    style,
    timeFrame,
    serviceDuration,
    includeHidden,
  },
  { skip } = {}
) =>
  useQuery(
    [
      'useCalendar',
      fromDate,
      toDate,
      subsystem,
      locationId,
      serviceId,
      serviceProviderId,
      style,
      appointmentId,
      timeFrame,
      serviceDuration,
      includeHidden,
    ],
    () =>
      getCalendar({
        fromDate,
        toDate,
        subsystem,
        locationId,
        serviceId,
        serviceProviderId,
        style,
        appointmentId,
        timeFrame,
        serviceDuration,
        includeHidden,
      }),
    { enabled: !!fromDate && !!toDate && !!locationId && !!serviceId && !skip }
  )

const useSbmCalendar = ({
  serviceId,
  locationId,
  subsystem,
  serviceProviderId,
  serviceDuration,
}) => {
  const { fromDate, toDate } = getDateRange(serviceId)
  const {
    data,
    isLoading: loading,
    error,
  } = useQuery(
    [
      'useSbmCalendar',
      serviceId,
      locationId,
      subsystem,
      serviceProviderId,
      serviceDuration,
      fromDate,
      toDate,
    ],
    () =>
      getCalendar({
        locationId,
        serviceId,
        fromDate,
        toDate,
        style: 'dense',
        subsystem,
        serviceProviderId,
        serviceDuration,
      }),
    { enabled: !!locationId && !!serviceId }
  )

  return {
    days: data || [],
    loading,
    error,
  }
}

export default useSbmCalendar
